import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58df84e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bill__container" }
const _hoisted_2 = { class: "bill__container__content" }
const _hoisted_3 = { class: "fl-row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form = _resolveComponent("app-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_operates = _resolveComponent("app-operates")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_form, {
        "search-list": _ctx.searchList,
        "search-data": _ctx.filterParams,
        onHandleSearch: _ctx.onRefreshTable
      }, null, 8, ["search-list", "search-data", "onHandleSearch"]),
      _createVNode(_component_app_operates, { mg: "10px 0" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-right":"15px"},
            onClick: _ctx.onExport
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_app_table, {
        ref: "tableRef",
        size: "default",
        "row-key": "id",
        "show-pagination": true,
        columns: _ctx.tableColumns,
        data: _ctx.loadTableData,
        scroll: { x:'100%', y: 500 }
      }, {
        billStartTime: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(record.billStartTime) + " — " + _toDisplayString(record.billEndTime), 1)
        ]),
        action: _withCtx(({ record }) => [
          _createElementVNode("span", _hoisted_3, [
            (record.status === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _withModifiers(($event: any) => (_ctx.handlerOperate('confirm', record)), ["prevent"])
                  }, "确认/驳回", 8, _hoisted_4),
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _withModifiers(($event: any) => (_ctx.handlerOperate('detail', record)), ["prevent"])
            }, "账单明细", 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.confirmVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmVisible) = $event)),
      title: "入账确认",
      onOk: _ctx.onConfirm,
      onClose: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.confirmParams,
          "label-col": { span: 5 },
          rules: _ctx.confirmRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "入账状态",
              name: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.confirmParams.status,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmParams.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("确认")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("驳回")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.confirmParams.status === '2')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "驳回原因",
                  name: "refuseReason"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.confirmParams.refuseReason,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmParams.refuseReason) = $event)),
                      rows: "2",
                      maxlength: 200,
                      "show-count": true,
                      placeholder: "请填写驳回原因"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onClose"])
  ]))
}